module.exports = __webpack_public_path__ + "static/media/fab-agent.363540b2.svg";